import { render, staticRenderFns } from "./wallet_transaction_types.vue?vue&type=template&id=61408eab&scoped=true&"
import script from "./wallet_transaction_types.vue?vue&type=script&lang=js&"
export * from "./wallet_transaction_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61408eab",
  null
  
)

export default component.exports